(function () {
    'use strict';

    angular.module('NaviaqWebApp').controller('unitsDetailsModalAdministrationController', unitsDetailsModalAdministrationController);

    unitsDetailsModalAdministrationController.$inject = [
        '$translate',
        '$rootScope',
        '$scope',
        '$windowInstance',
        'unit',
        'currentFormType',
        'formTypes',
        'unitService',
        'unitGroups',
        'supplierService',
        'productCatalogService',
        'baseDataService'
    ];

    async function unitsDetailsModalAdministrationController(
        $translate,
        $rootScope,
        $scope,
        $windowInstance,
        unit,
        currentFormType,
        formTypes,
        unitService,
        unitGroups,
        supplierService,
        productCatalogService,
        baseDataService
    ) {

        $scope.close = close;
        $scope.validateForm = validateForm;

        $scope.isEdit = currentFormType == formTypes.edit;

        $scope.unit = {};
        
        $scope.unitGroups = [];
        $scope.selectedUnitGroup = null;
        
        $scope.suppliers = [];
        $scope.selectedSupplier = null;
        
        $scope.supplierProducts = [];
        $scope.selectedSupplierProduct = null;
        
        $scope.unitResourceComponentTypes = [];
        $scope.selectedResources = null;
        
        $scope.unitGroupsOptions = {
            dataSource: new kendo.data.DataSource({
                data: unitGroups.sort((a, b) => a.description.localeCompare(b.description))
            }),
            dataValueField: 'id',
            dataTextField: 'description',
            optionLabel: $translate.instant('ADMIN_UNITS_SELECT_PRODUCT_GROUP'),
            select: unitGroupSelect,
            dataBound: function (e) {
                const data = this.dataSource.view();
                if (!$scope.isEdit) {
                 
                }
            }
        };

        $scope.suppliersOptions = {
            dataValueField: 'supplierId',
            dataTextField: 'name',
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: e =>  e.success($scope.suppliers)
                }
            }),
            optionLabel: ' ',
            filter: 'contains',
            change: () => {
                if ($scope.selectedSupplier && $scope.selectedSupplier.supplierId === '') {
                    $scope.selectedSupplier = null;
                }

                refreshProductsList($scope.selectedResources);
            },
        };

        $scope.resourcesOptions = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: e => e.success($scope.unitResourceComponentTypes.sort((a, b) => a.resourceDescription > b.resourceDescription ? 1 : -1))
                }
            }),
            dataValueField: 'resourceId',
            dataTextField: 'resourceDescription',
            optionLabel: $translate.instant('ADMIN_UNITS_SELECT_RESOURCE'),
            filter: 'contains',
            select: resourcesSelect,
        };

        $scope.supplierProductsOptions = {
            dataSource: new kendo.data.DataSource({
                transport: {
                    read: e => e.success($scope.supplierProducts)
                }
            }),
            template: (dataItem) => { return dataItem.name + ' (' + dataItem.articleNumber + ')' },
            dataValueField: 'articleNumber',
            dataTextField: 'name',
            optionLabel: $translate.instant('G_SELECT'),
            filter: 'contains',
            select: supplierProductSelect,
        };

        await initController();

        async function initController() {
            $scope.unitGroups = unitGroups;

            $scope.resources = await baseDataService.getResourcesWebApi();
            const componentTypeMap = new Map((await productCatalogService.getComponentTypes()).map(c => [c.key, c]));

            $scope.unitResourceComponentTypes = $scope.resources.flatMap(r => {
                const m = componentTypeMap.get(r.resourceExternalId);
                if (m) {
                    return [{ ...r, ...m, resourceDescription: m.value }];
                } else if (r.resourceExternalId == null) {
                    return [{ ...r }];
                } else {
                    return [{ ...r, resourceDescription: r.resourceDescription }];
                }
            });
            $scope.resourcesOptions.dataSource.read();   
          
            if (currentFormType === formTypes.add) {
                $scope.selectedUnitGroup = $scope.unitGroups.find(u => u.isMooringProduct == true) || data[0];
                
                let supplierTypes = getUnitGroupSupplierTypes($scope.selectedUnitGroup);

                $scope.suppliers = await supplierService.getSuppliersByFilter({
                    IsActive: true,
                    SupplierTypes: supplierTypes
                });
                $scope.suppliersOptions.dataSource.read();

                $scope.unitResourceComponentTypes = $scope.unitResourceComponentTypes.filter(r => r.resourceExternalId != null);
                $scope.resourcesOptions.dataSource.read();   
            }

            if (currentFormType === formTypes.edit && unit) {
                $scope.unit = unit;
                
                $scope.selectedUnitGroup = unitGroups.find(function (unitGroup) {
                    return unitGroup.id == $scope.unit.unitGroupId;
                });

                let supplierTypes = getUnitGroupSupplierTypes($scope.selectedUnitGroup);

                $scope.suppliers = await supplierService.getSuppliersByFilter({
                    IsActive: true,
                    SupplierTypes: supplierTypes
                });
                $scope.suppliersOptions.dataSource.read();

                if ($scope.unit.supplierId) {
                    $scope.selectedSupplier = $scope.suppliers.find(s => s.supplierId === unit.supplierId);
                    $scope.suppliersOptions.dataSource.read();
                    $scope.supplier.value($scope.selectedSupplier?.supplierId);
                    $scope.supplier.trigger("change");
                }
                
                if ($scope.unit.resourceId) {
                    $scope.selectedResources = $scope.unitResourceComponentTypes.find(function (resource) {
                        return resource.resourceId == $scope.unit.resourceId;
                    });
                    $scope.resourcesOptions.dataSource.read();
                }
                
                if ($scope.selectedSupplier && $scope.selectedResources && $scope.selectedResources.resourceExternalId) {
                    let vendorProducts = 
                        (await productCatalogService.getSupplierProductCatalogByFilter(
                            {
                                vendorId: $scope.selectedSupplier.supplierId,
                                componentType: $scope.selectedResources.resourceExternalId
                            }
                        ))
                        .sort((a, b) => a.productName > b.productName ? 1 : -1);

                    $scope.supplierProducts = vendorProducts;
                    
                    if ($scope.unit.externalUnitId) {
                        $scope.selectedSupplierProduct = $scope.supplierProducts.find(function (supplierProduct) {
                            return supplierProduct.articleNumber == $scope.unit.externalUnitId && 
                                $scope.selectedSupplier.supplierId == $scope.unit.supplierId;
                        });
                    }

                    $scope.supplierProductsOptions.dataSource.read();
                    $scope.supplierProductsDropdownList.value($scope.selectedSupplierProduct?.articleNumber);
                    $scope.supplierProductsDropdownList.trigger("change");
                }
            }
        }

        function validateForm(event) {
            event.preventDefault();
            if ($scope.validator.validate()) {
                $rootScope.$broadcast('showBusyIndicator', {
                    id: 'unitDetailsModalIndicator',
                    destination: '.k-widget.k-window',
                    overlay: true
                });

                $scope.unit.unitGroupId = $scope.selectedUnitGroup ? $scope.selectedUnitGroup.id : null;
                $scope.unit.resourceId = $scope.selectedResources ? $scope.selectedResources.resourceId : null;
                $scope.unit.measurementUnitTypeId = $scope.selectedResources ? $scope.selectedResources.measurementUnitTypeId : null;
                $scope.unit.supplierId = $scope.selectedSupplier ? $scope.selectedSupplier.supplierId : null;
                normalizeUnitPrices($scope.unit);

                switch (currentFormType) {
                    case formTypes.add:
                        $scope.unit.contractorId = $rootScope.authData.contractorId;

                        unitService.addUnit($scope.unit)
                            .then(unit => close($scope.unit))
                            .catch(() => close());
                        break;
                    case formTypes.edit:

                        unitService.updateUnit($scope.unit)
                            .then(unit => close($scope.unit))
                            .catch(() => close());
                        break;
                    default:
                        close();
                        break;
                }
            }
        }

        function normalizeUnitPrices(unit) {
            unit.standardPrice = normalizePriceValue(unit.standardPrice);
            unit.inPrice = normalizePriceValue(unit.inPrice);
        }

        function normalizePriceValue(priceValue) {
            if (priceValue == null) {
                return 0;
            }

            if (typeof priceValue === 'string' && priceValue.trim() === '') {
                return 0;
            }

            return priceValue;
        }

        function getUnitGroupSupplierTypes(selectedUnitGroup) {
            let typesList = [];
            if (selectedUnitGroup) {
                if (selectedUnitGroup.isMooringProduct) {
                    typesList.push("Mooring");
                }
                if (selectedUnitGroup.isNetProduct) {
                    typesList.push("Net");
                }
                if (selectedUnitGroup.isLiceSkirtProduct) {
                    typesList.push("LiceSkirt");
                }
                if (selectedUnitGroup.isRingProduct) {
                    typesList.push("Ring");
                }
            }

            return typesList;
        }

        function unitGroupSelect(e) {
            var selected = e.dataItem;
            var supplierTypes = getUnitGroupSupplierTypes(selected);
            var filter = {
                IsActive: true,
                SupplierTypes: supplierTypes
            };

            supplierService.getSuppliersByFilter(filter)
                .then(result => {
                    $scope.suppliers = result;
                    $scope.suppliersOptions.dataSource.read();
                })
                .catch(error => console.log(error));

            refreshProductsList({});
            resetResource();
            resetSupplier();
        }

        function resourcesSelect(e) {
            refreshProductsList(e.dataItem);
        }

        function supplierProductSelect(e) {
            var product = e.dataItem;
            setSelectedSupplierProductData(product);
        }

        function resetResource() {
            $scope.selectedResources = null;
        }

        function resetSupplier() {
            $scope.selectedSupplier = null;
        }

        function refreshProductsList(selectedResourceCategory) {
            if (!($scope.selectedUnitGroup && $scope.selectedSupplier && selectedResourceCategory && selectedResourceCategory.resourceExternalId)) {
                $scope.supplierProducts = [];
                $scope.selectedSupplierProduct = null;
                $scope.supplierProductsOptions.dataSource.read();
                return;
            }
            
            var filter = {
                vendorId: $scope.selectedSupplier.supplierId,
                componentType: selectedResourceCategory.resourceExternalId
            };

            productCatalogService.getSupplierProductCatalogByFilter(filter).then(productsList => {
                $scope.supplierProducts = productsList.sort((a, b) => a.productName > b.productName ? 1 : -1);
                $scope.supplierProductsOptions.dataSource.read();
            });

            setSelectedSupplierProductData({});
        }

        function setSelectedSupplierProductData(selectedSupplierProduct) {
            const hasValidProductId = selectedSupplierProduct?.articleNumber?.trim() != '';
            if (hasValidProductId) {
                $scope.selectedSupplierProduct = selectedSupplierProduct;
                $scope.unit.externalUnitId = selectedSupplierProduct.articleNumber;
                $scope.unit.description = selectedSupplierProduct.name;
            } else {
                $scope.selectedSupplierProduct = null;
            }
        }

        function close(param) {
            $rootScope.$broadcast('hideBusyIndicator', 'unitDetailsModalIndicator');
            $windowInstance.close(param);
        }
    }
})();
